import { IncidentSeverity } from './incident-severity.enum';

export enum AccidentTypeFilter {
  All = 0,
  Minor = 1,
  Intermediate = 2,
  Major = 3
}

export const AccidentTypeSeverityTypes: Record<AccidentTypeFilter, IncidentSeverity[]> = {
  [AccidentTypeFilter.All]: [IncidentSeverity.LowImpact, IncidentSeverity.MediumImpact, IncidentSeverity.HighImpact],
  [AccidentTypeFilter.Minor]: [IncidentSeverity.LowImpact],
  [AccidentTypeFilter.Intermediate]: [IncidentSeverity.MediumImpact],
  [AccidentTypeFilter.Major]: [IncidentSeverity.HighImpact]
}